import React, { FC, useState, useEffect } from 'react'
import { IonModal, IonContent } from '@ionic/react'
import { MktButton, PasswordInput, VerifyCodeInput, UseHeader } from '@cps'
import { toast } from '@utils'
import { memberMobx } from '@mobxStore'
import { observer } from 'mobx-react'
import i18n from 'i18next'
import './index.scss'

// interface
interface IProps {
  title?: string;
  type: 'mobile' | 'email';
  account: string;
  countryCode: string;
  reject?: () => void;
  resolve?: () => void;
}

const verifyCodeType = memberMobx.verifyCodeTypes.resetPassword

const Forget: FC<IProps> = (props: IProps) => {
  const {
    title,
    type,
    account,
    countryCode,
    resolve,
    reject,
  } = props
  const [verifyCodeInfo, setVerifyCodeInfo] = useState<any>({})
  const [passwordInfo, setPasswordInfo] = useState<any>({})
  // Component Event
  const handleFinish = () => {
    if (!verifyCodeInfo.inputValue) {
      toast({ message: i18n.t('mkt.common.tipCode') })
      return
    }
    if (!passwordInfo.inputValue) {
      toast({ message: i18n.t('mkt.common.tipPassword') })
      return
    } else if (!passwordInfo.valid) {
      toast({ message: i18n.t('mkt.common.tipPassword') })
      return
    }
    const params: any = {}
    if (type === 'mobile') {
      params.mobile = account
      params.countryCode = countryCode
    } else if (type === 'email') {
      params.email = account
    }
    params.captcha = verifyCodeInfo.inputValue
    params.newPwd = passwordInfo.inputValue
    memberMobx.resetPassword(params).then((res: any) => {
      if (res) {
        resolve && resolve()
      }
    })
  }
  useEffect(() => {
    setVerifyCodeInfo({})
    setPasswordInfo({})
  }, [])
  return (
    <IonModal
      cssClass='forget-page'
      isOpen
    >
      <UseHeader onBack={reject}></UseHeader>
      <IonContent className='page-content'>
        <div className='panel'>
          <div className='title'>{title || i18n.t('pageName.forget')}</div>
          <div className='des'>
            <span>{i18n.t('mkt.member.isSendCode', { name: type === 'email' ? account : `+${countryCode} ${account}` })}，{i18n.t('mkt.member.passwordDes')}</span>
          </div>
          <div className='body'>
            <VerifyCodeInput autoSend codeType={verifyCodeType} account={account} accountType={type} countryCode={countryCode} onChange={(val: any) => setVerifyCodeInfo(val)} />
            <div className='input-item'>
              <PasswordInput onChange={(val: any) => setPasswordInfo(val)} />
            </div>
          </div>
          <div className='footer'>
            <MktButton text={i18n.t('mkt.common.finish')} data-cypid='forgetModalConfirm' onClick={handleFinish} />
          </div>
        </div>
      </IonContent>
    </IonModal>
  )
}

export default observer(Forget)
